import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faMoneyBillWave, faCarCrash } from '@fortawesome/free-solid-svg-icons';
import SectionHeader from '../common/SectionHeader';
import Container from '../common/Container'; // ✅ PASSO 1: Importe o componente Container

const WhyWrapper = styled.section`
    padding: 100px 0;
    background-color: ${({ theme }) => theme.colors.lighter};
`;

const RiskGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
`;

const RiskCard = styled.div`
    background: ${({ theme }) => theme.colors.lighter};
    border-radius: ${({ theme }) => theme.radii.lg};
    padding: 40px 30px;
    box-shadow: ${({ theme }) => theme.shadows.sm};
    transition: ${({ theme }) => theme.transitions.default};
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.03);

    &:hover {
        transform: translateY(-10px);
        box-shadow: ${({ theme }) => theme.shadows.lg};
    }
`;

const RiskIcon = styled.div`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;
    font-size: 32px;
    color: white;

    &.danger {
        background: linear-gradient(135deg, ${({ theme }) => theme.colors.danger} 0%, #ff7675 100%);
    }
    &.warning {
        background: linear-gradient(135deg, ${({ theme }) => theme.colors.warning} 0%, #ffeaa7 100%);
    }
    &.primary {
        background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.primaryLight} 100%);
    }
`;

const RiskTitle = styled.h3`
    font-size: 22px;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.dark};
`;

const RiskText = styled.p`
    color: ${({ theme }) => theme.colors.gray};
    line-height: 1.7;
`;

const WhySection = () => {
    const risks = [
        { icon: faExclamationTriangle, title: "Risco de Golpes", text: "15% dos veículos usados à venda possuem indícios de fraude ou documentação irregular.", type: "danger" },
        { icon: faMoneyBillWave, title: "Débitos Ocultos", text: "O comprador médio descobre R$ 2.300 em débitos após a compra do veículo.", type: "warning" },
        { icon: faCarCrash, title: "Acidentes Não Declarados", text: "20% dos veículos usados já sofreram acidentes graves que não são informados.", type: "primary" }
    ];

    return (
        <WhyWrapper>
            {/* ✅ PASSO 2: Substitua a div pelo componente Container */}
            <Container>
                <SectionHeader 
                    title="Não corra riscos desnecessários" 
                    subtitle="1 em cada 5 veículos usados no Brasil possui irregularidades ocultas"
                />
                <RiskGrid>
                    {risks.map(risk => (
                        <RiskCard key={risk.title}>
                            <RiskIcon className={risk.type}>
                                <FontAwesomeIcon icon={risk.icon} />
                            </RiskIcon>
                            <RiskTitle>{risk.title}</RiskTitle>
                            <RiskText>{risk.text}</RiskText>
                        </RiskCard>
                    ))}
                </RiskGrid>
            </Container>
        </WhyWrapper>
    );
};

export default WhySection;
